/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Delete_ValueInputs */

const en_us2_search_field_delete_value = /** @type {(inputs: Search_Field_Delete_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closes your account in this app`)
};

const pt_br2_search_field_delete_value = /** @type {(inputs: Search_Field_Delete_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encerra a conta neste app`)
};

const es_419_search_field_delete_value = /** @type {(inputs: Search_Field_Delete_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cierra tu cuenta en esta app`)
};

const pt_pt2_search_field_delete_value = /** @type {(inputs: Search_Field_Delete_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encerra a tua conta nesta app`)
};

const fr_fr2_search_field_delete_value = /** @type {(inputs: Search_Field_Delete_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferme ton compte dans cette app`)
};

const de_de2_search_field_delete_value = /** @type {(inputs: Search_Field_Delete_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließt dein Konto in dieser App`)
};

const it_it2_search_field_delete_value = /** @type {(inputs: Search_Field_Delete_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiude il tuo account in questa app`)
};

/**
* | output |
* | --- |
* | "Closes your account in this app" |
*
* @param {Search_Field_Delete_ValueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_delete_value = /** @type {((inputs?: Search_Field_Delete_ValueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Delete_ValueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_delete_value(inputs)
	if (locale === "es-419") return es_419_search_field_delete_value(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_delete_value(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_delete_value(inputs)
	if (locale === "de-DE") return de_de2_search_field_delete_value(inputs)
	if (locale === "it-IT") return it_it2_search_field_delete_value(inputs)
	return en_us2_search_field_delete_value(inputs)
});
export { search_field_delete_value as "search.field_delete_value" }